module.exports = __webpack_public_path__ + "img/ico_smile.d2948176.svg";